import { render, staticRenderFns } from "./type_activity_2.vue?vue&type=template&id=a1f9cad2"
import script from "./type_activity_2.vue?vue&type=script&lang=js"
export * from "./type_activity_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports